export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    VALIDATE_SESSION: '/auth/validate-session',
    CHANGE_PASSWORD: '/auth/change-password',
    CHANGE_PASSWORD_AFTER_LOGIN: '/auth/change-password-after-login',
    UPDATE_PROFILE: '/auth/update-profile',
    REFRESH_TOKEN: '/auth/refresh-token',
    SIGNUP: 'auth/signup',
    SIGNUP_WITHOUT_PAYMENT: 'auth/signup-without-payment',
    TOKENS: 'auth/tokens',
    CONFIRM_SIGNUP: 'auth/confirm-signup',
    RESEND_CONFIRMATION: 'auth/resend-confirmation',
    WORKSPACE: 'auth/workspace',
    COMPANIES: 'auth/companies',
    UPDATE_ADDON_ACCOUNTS: 'auth/admin/user-update',
    FORGOT_PASSWORD: 'auth/forgot-password',
    CONFIRM_FORGOT_PASSWORD: 'auth/confirm-forgot-password',
    GENERATE_SUBDOMAIN: 'auth/generate-subdomain',
    CHECK_SUBDOMAIN: 'auth/check-subdomain',
    UPLOAD_PROFILE_PHOTO: 'auth/upload-profile-photo',
    SEND_LOGIN_OTP: 'auth/login-otp',
    VERIFY_LOGIN_OTP: 'auth/verify-login-otp',
    CUSTOM_DOMAIN: 'auth/companies',
    CONFIRM_MFA: 'auth/confirm-mfa',
    LINK_COGNITO_ACCOUNTS: '/auth/link-cognito-accounts',
    DELETE_COGNITO_USER: '/auth/delete-cognito-user',
    EASYWEBINAR_TIMEZONES: '/auth/easywebinar-timezones',
    CHECK_EMAIL_EXISTS: '/auth/check-email-exists',
  },
  EVENTS_LOGGER: {
    LOG_EVENT: '/events-logger/log-event',
    EVENTS_BY_EMAIL: '/events-logger/events/email',
    LATEST_SIGNUP_EVENT: '/events-logger/events/signup/latest',
    EVENTS_BY_TYPE: '/events-logger/events/type',
  },
  SUBSCRIPTIONS: {
    GET_CUSTOMER_INVOICES: (customerId: string) => `/subscriptions/customer/${customerId}/invoices`,
    DOWNLOAD_INVOICE: (invoiceId: string) => `subscriptions/invoice/${invoiceId}/download`,
    GET_PORTAL_SESSION: (customerId: string) => `subscriptions/customer/${customerId}/portal-session`,
    GET_SUBSCRIPTION_DETAILS: (customerId: string) => 
      `subscriptions/customer/${customerId}/subscription-details`,
    UPGRADE_PLAN: 'subscriptions/upgrade-plan',
    GET_PLANS: 'subscriptions/plans',
    GET_PLAN_BY_ID: (planId: string) => `subscriptions/planById/${planId}`,
    VALIDATE_COUPON: (couponCode: string, planId?: string) => 
      `subscriptions/coupon/${couponCode}${planId ? `?planId=${planId}` : ''}`,
    ADD_PAYMENT_SOURCE: 'subscriptions/payment-source',
    CREATE_SUBSCRIPTION: '/subscriptions',
    CHANGE_PLAN: '/subscriptions/change-plan',
    GET_BILLING_DETAILS: (customerId: string) => `/subscriptions/customer/${customerId}/billing-details`,
    CANCEL_SUBSCRIPTION: (subscriptionId: string) => `subscriptions/cancel/${subscriptionId}`,
    CUSTOMER_CHARGE: '/subscriptions/customer/charge',
    CHANGE_PLAN_BY_EMAIL: '/subscriptions/change-plan-by-email',
    GET_PAYMENT_METHOD_STATUS: (customerId: string) => `/subscriptions/customer/${customerId}/payment-method-status`,
    QUICK_CHARGE: '/subscriptions/quick-charge',
    EXTEND_BILLING_DATE: (subscriptionId: string, days: number) => `/subscriptions/extend-billing-date/${subscriptionId}?days=${days}`,
    CANCELLATION_REASON: '/subscriptions/cancellation-reason',
  },
  USAGE: {
    FETCH: '/subscriptions/usage/'
  },
  LEAD_SQUARED: {
    CREATE_LEADS: '/leadsquared/create-lead',
    JOIN_ACTIVITY: '/leadsquared/join-activity',
    GET_LEADS_BY_EMAIL: '/leadsquared/get-ls-prospect-id?email=',
    UPDATE_LS_FIELD: '/leadsquared/update-ls-fields',
  },
  SUPER_ADMIN: {
    MIGRATE_USER: '/super-admin/migrate-user',
    GET_CANCELLATIONS: '/super-admin/cancellation-reasons',
  }
} as const;
